import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getShiftDetailsRequest: ['shiftId'],
  getShiftDetailsSuccess: ['response'],
  getShiftDetailsFailure: null,

  createTimeClockRequest: ['shiftId', 'payload'],
  createTimeClockSuccess: ['response'],
  createTimeClockFailure: null,

  updateTimeClockRequest: ['shiftId', 'timeClockId', 'payload'],
  updateTimeClockSuccess: ['response'],
  updateTimeClockFailure: ['timeClockId'],

  deleteTimeClockRequest: ['shiftId', 'timeClockId', 'timeClockType'],
  deleteTimeClockSuccess: ['timeClockId', 'timeClockType'],
  deleteTimeClockFailure: ['timeClockId'],

  createIndividualCommissionsRequest: ['shiftId', 'payload'],
  createIndividualCommissionsSuccess: ['response'],
  createIndividualCommissionsFailure: null,

  updateIndividualCommissionsRequest: ['shiftId', 'payload'],
  updateIndividualCommissionsSuccess: ['response'],
  updateIndividualCommissionsFailure: null,

  deleteIndividualCommissionsRequest: ['shiftId'],
  deleteIndividualCommissionsSuccess: null,
  deleteIndividualCommissionsFailure: null,

  createTeamCommissionsRequest: ['shiftId', 'payload'],
  createTeamCommissionsSuccess: ['response'],
  createTeamCommissionsFailure: null,

  updateTeamCommissionsRequest: ['shiftId', 'payload'],
  updateTeamCommissionsSuccess: ['response'],
  updateTeamCommissionsFailure: null,

  deleteTeamCommissionsRequest: ['shiftId'],
  deleteTeamCommissionsSuccess: null,
  deleteTeamCommissionsFailure: null,

  createPerVehicleCommissionsRequest: ['shiftId', 'payload'],
  createPerVehicleCommissionsSuccess: ['response'],
  createPerVehicleCommissionsFailure: null,

  updatePerVehicleCommissionsRequest: ['shiftId', 'payload'],
  updatePerVehicleCommissionsSuccess: ['response'],
  updatePerVehicleCommissionsFailure: null,

  deletePerVehicleCommissionsRequest: ['shiftId'],
  deletePerVehicleCommissionsSuccess: null,
  deletePerVehicleCommissionsFailure: null,

  // Clear all caches
  clearShiftDetailsRequest: null,
});

export const ShiftDetailsTypes = Types;
export default Creators;
